module.exports = __webpack_public_path__ + "674f50d287a8c48dc19ba404d20fe713.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fontawesome-webfont.eot
// module id = 1492
// module chunks = 0